<template>
  <div class="home-categories">
    <button
      v-for="item in items"
      :key="item.id"
      type="button"
      class="chip"
      @click="choose(item.id)"
    >
      <span class="chip__icon">
        <IconBase
          class="chip__img"
          :path="`category/${item.id}.svg`"
        />
      </span>
      <span class="chip__label">{{ item.name }}</span>
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { IconBase } from '@/UI'
import { useMainEntities } from '@/states/mainEntities'
import { useMapStore } from '@/states/mapStore'
import { useCategoryStore } from '@/states/categoryStore'

// Сначала товары, выгул, передержка, вет. услуги, груминг — остальные следом
const PRIORITY = [5, 4, 3, 1, 2]

const router = useRouter()
const mainEntities = useMainEntities()
const mapStore = useMapStore()
const { categoryChoosed } = useCategoryStore()

const items = computed(() => {
  const all = mainEntities.category || []
  const onMap = new Set(mapStore.placemarks.map((el) => el.category_id))
  const available = onMap.size ? all.filter((el) => onMap.has(el.id)) : all

  const rank = (id) => {
    const index = PRIORITY.indexOf(id)
    return index === -1 ? PRIORITY.length : index
  }

  return [...available].sort((a, b) => rank(a.id) - rank(b.id))
})

const choose = (id) => {
  categoryChoosed.value = id
  router.push('/category')
}
</script>

<style lang="scss" scoped>
.home-categories {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  margin: 0 -20px;
  padding: 0 20px 4px;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
}

.chip {
  flex: none;
  display: flex;
  align-items: center;
  gap: 10px;
  height: 56px;
  padding: 0 20px 0 8px;
  border: 0;
  border-radius: 28px;
  background: #fff;
  cursor: pointer;

  &__icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #f2f8ff;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__img {
    width: 24px;
    height: 24px;
  }

  &__label {
    font-size: 15px;
    font-family: "NunitoBold";
    color: #26384b;
    white-space: nowrap;
  }
}

[theme="dark"] {
  .chip {
    background: #37363c;
  }

  .chip__icon {
    background: #292929;
  }

  .chip__label {
    color: #fff;
  }
}
</style>
